module.exports = __webpack_public_path__ + "static/media/web-invoice.37a8f9b6.png";